import { Card, Progress, Typography, Dropdown, Space } from "antd";
import { DownOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const ProgressCard = ({ percentage, period, onPeriodChange }) => {
  
const periodOptions = [
  { key: "7d", label: "Weekly" },
  { key: "30d", label: "Monthly" },
  { key: "12m", label: "Yearly" },
];

  const periodLabels = {
    "7d": "Weekly",
    "30d": "Monthly",
    "12m": "Yearly",
  };


  return (
    <Card
      style={{
        background: "rgba(88, 80, 109, 0.30)",
        borderRadius: 18,
        border: "none",
        width: 320,
      }}
      styles={{
        body: {
          padding: "8px 16px 8px 16px",
        },
      }}
    >
      <Dropdown menu={{ items: periodOptions, onClick: ({key}) => onPeriodChange(key) }} trigger={["click"]}>
        <Space style={{ cursor: "pointer", marginBottom: 8 }}>
          <Text style={{ color: "#94a3b8" }}>
            Adherence {periodLabels[period] || period}
          </Text>
          <DownOutlined style={{ color: "#94a3b8", fontSize: 12 }} />
        </Space>
      </Dropdown>
      {/* Row: Percentage + Progress */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 5,
        }}
      >
        <Title
          level={2}
          style={{
            color: "#fff",
            margin: 0,
            minWidth: 70,
          }}
        >
          {Math.round(percentage)}%
        </Title>

        <Progress
          percent={percentage}
          showInfo={false}
          strokeColor="#22c55e"
          trailColor="#2a2438"
          strokeWidth={10}
          style={{ flex: 1 }}
        />
      </div>
    </Card>
  );
};

export default ProgressCard;
